import { useTranslation } from 'react-i18next'
import {
  StatusBar,
  StatusBarL,
  StatusBarR,
  StatusDot,
  StatusWarn,
} from '../../../components/chatflow/styles'

/**
 * EditorStatusBar — Bottom status bar of the editor.
 *
 * Displays node/connection counts, warnings and keyboard shortcuts.
 * Purely presentational component: receives `stats` via prop.
 */
interface EditorStatusBarProps {
  stats: {
    nodes: number;
    edges: number;
    warns: number;
  };
}

export default function EditorStatusBar({ stats }: EditorStatusBarProps) {
  const { t } = useTranslation()

  const nodesLabel = t(`status_bar.nodes_${stats.nodes === 1 ? 'one' : 'other'}`, { count: stats.nodes })
  const edgesLabel = t(`status_bar.connections_${stats.edges === 1 ? 'one' : 'other'}`, { count: stats.edges })

  return (
    <StatusBar>
      <StatusBarL>
        <StatusDot $warn={stats.warns > 0} />
        <span>{nodesLabel} · {edgesLabel}</span>
        {stats.warns > 0 && (
          <StatusWarn>· {stats.warns} {t('status_bar.no_message')}</StatusWarn>
        )}
      </StatusBarL>
      <StatusBarR>
        <kbd>⌘S</kbd> {t('status_bar.shortcut_save')}
        <kbd>⌘Z</kbd> {t('status_bar.shortcut_undo')}
        <kbd>⌘D</kbd> {t('status_bar.shortcut_duplicate')}
      </StatusBarR>
    </StatusBar>
  )
}
